import * as React from 'react'
import { Row, IconButton } from '@livechat/ui-kit'
import ChevronLeftIcon from './ChevronLeftIcon';
import ChevronRightIcon from './ChevronRightIcon';
import { ComposedMessage } from './ComposedMessage';

export class CardCarousal extends React.Component {
	state = {
		pos: 0
	};

	next = () => {
		this.setState(state => ({pos: state.pos + 1}))
	}
	prev = () => {
		this.setState(state => ({pos: state.pos - 1}))
	}
	render() {
		const {cards, ownId, sendMessage} = this.props;
		const {pos} = this.state;
		return (
			<Row
				style={{overflow: "visible", position: "relative", left: -38}}
			>
				<IconButton disabled={pos === 0} onClick={this.prev}>
					<ChevronLeftIcon disabled={pos === 0}/>
				</IconButton>
				<div
					style={{
						width: 250,
						overflowX: "hidden",
					}}
				>
					<div 
						style={{
							display: "flex",
							flexWrap: "nowrap",
							transform: `translate3d(-${208*pos}px, 0px, 0px)`,
						}}
					>
						{cards.map(card => (
							<ComposedMessage
								key={card.id}
								ownId={ownId}
								style={{
									width: 200,
								}}
								bubbleStyle={{
									borderRadius: 0,
								}}
								message={card}
								sendMessage={sendMessage}
							/>
						))}
					</div>
				</div>
				<IconButton disabled={pos === cards.length - 1} onClick={this.next}>
					<ChevronRightIcon disabled={pos === cards.length - 1}/>
				</IconButton>
			</Row>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CardCarousal.js